import type { ISceneObj } from 'src/types/SceneType';

/** Scene payloads may store list fields as array-like objects from legacy APIs. */
export function asSceneList(value: unknown): any[] {
	if (!value) return [];
	if (Array.isArray(value)) return value;
	if (typeof value === 'object') return Object.values(value as Record<string, unknown>);
	return [];
}

export function getSceneActions(scene: ISceneObj | undefined): any[] {
	return asSceneList(scene?.do);
}

export function getSceneConditions(scene: ISceneObj | undefined): any[] {
	if (!scene?.if) return [];

	const fromOr = scene.if.or;
	if (fromOr) return asSceneList(fromOr);

	const andWithOr = scene.if.and?.find((el: any) => el?.or !== undefined);
	return asSceneList(andWithOr?.or);
}
